import {useState} from 'react'
import {CampModel, ClientModel, CompanyModel, SiteModel, UserModel} from '../../central/model'
import {
  getCamp,
  getClient,
  getCompany,
  getEnterprise,
  getSite,
  getUser,
} from '../../central/services'
import {SelectOption} from '../../../models/utility.model'
import {PointModel} from '../model'
import {getPoint, getPointByOrdersLote} from '../services'
import {getRoomsService} from '../../hoteleria/services/room.service'
import {getMasterModuleService} from '../../hoteleria/features/modules/services'
import {getGuestsService} from '../../hoteleria/services/guest.service'

export const useLaundryFilter = () => {
  const [company, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [rooms, setRooms] = useState<SelectOption[]>([])
  const [washedOrdenStatus, setWashedOrdenStatus] = useState<SelectOption[]>([])
  const [contratist, setContratist] = useState<SelectOption[]>([])
  const [laundryPoint, setLaundryPoint] = useState<SelectOption[]>([])
  const [laundryPointByOrder, setLaundryPointByOrder] = useState<SelectOption[]>([])
  const [guests, setGuests] = useState<SelectOption[]>([])
  const [collaborator, setCollaborator] = useState<SelectOption[]>([])

  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombreEmpresa,
    }))
    setCompany(mappedSites)
  }

  const getClientList = async (id: string) => {
    let obj: ClientModel = {
      isCombo: true,
      companiaId: id,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }

  const getSiteList = async (id: string) => {
    let obj: SiteModel = {
      isCombo: true,
      clienteId: id,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }
  const getCampList = async (id: string) => {
    let obj: CampModel = {
      isCombo: true,
      siteId: id,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }

  const getRooms = async (id: string) => {
    let obj = {
      CampamentoId: id,
      isCombo: true,
    }
    try {
      const {data: response} = await getRoomsService({
        pageNumber: 1,
        size: 1000,
        ...obj,
      })
      const mappedRooms = response?.data?.map((item) => ({value: item.Id, label: item.Codigo}))
      setRooms(mappedRooms)
    } catch (error) {
      return []
    }
  }

  const getContratist = async () => {
    try {
      const response = await getEnterprise({isCombo: true}, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setContratist(mappedSites)
    } catch (error) {
      setContratist([])
    }
  }

  const getWashedOrderStatus = async (tableName = 'EstadoLavanderia') => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName,
      })
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.codigo, label: item.nombreCorto}))
      setWashedOrdenStatus([{value: '', label: 'TODOS'}, ...mappedSites])
    } catch (error) {
      setWashedOrdenStatus([])
    }
  }

  const getGuests = async (id: string) => {
    try {
      const response = await getGuestsService({
        CampamentoId: id,
        pageNumber: 1,
        size: 100,
      })
      const data = response.data.data
      const mappedSites = data.map((item) => ({
        value: item.Id,
        label: `${item.ApellidoPaterno} ${item.ApellidoMaterno} ${item.Nombres} (${item.TipoDocumento_descripcion} ${item.NumeroDocumento})`,
      }))
      setGuests(mappedSites)
    } catch (error) {
      setGuests([])
    }
  }

  const getUserList = async () => {
    let obj: UserModel = {
      isCombo: true,
    }
    const response = await getUser(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: `${item.apellidos} ${item.nombres} (${item.tipoDocumento} ${item.numeroDocumento})`,
    }))
    setCollaborator(mappedSites)
  }

  const getLaundryPointList = async ({
    companyId,
    clientId,
    siteId,
    campId,
  }: {
    companyId?: string
    clientId?: string
    siteId?: string
    campId?: string
  }) => {
    let obj: PointModel = {
      isCombo: true,
      companiaId: companyId,
      clienteId: clientId,
      siteId: siteId,
      campamentoId: campId,
    }

    const response = await getPoint(obj, 1)
    const data = response.data.data
    const mappedLaundryPoint = data.map((item) => ({value: item.id, label: item.nombre}))
    setLaundryPoint([{value: 'TODOS', label: 'TODOS'}, ...mappedLaundryPoint])
  }

  const getLaundryPointByOrderList = async () => {
    const response = await getPointByOrdersLote()
    const data = response.data.data
    const mappedLaundryPoint = data.map((item: any) => ({value: item.Id, label: item.Nombre}))
    setLaundryPointByOrder([{value: '', label: 'TODOS'}, ...mappedLaundryPoint])
  }

  const handleClearList = () => {
    setClient([])
    setSite([])
    setCamp([])
    setRooms([])
    setGuests([])
    setLaundryPoint([])
    setCollaborator([])
  }

  return {
    company,
    client,
    site,
    camp,
    rooms,
    guests,
    contratist,
    laundryPoint,
    washedOrdenStatus,
    collaborator,
    laundryPointByOrder,
    getCompanyList,
    getClientList,
    getSiteList,
    getCampList,
    getRooms,
    getLaundryPointList,
    handleClearList,
    getContratist,
    getWashedOrderStatus,
    getGuests,
    getUserList,
    getLaundryPointByOrderList,
  }
}
